import React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import { ReactComponent as SearchIcon } from '../../../../assets/images/TicketImages/search.svg';

const SearchInput = ({ value, onChange, onClear, activeFilters = [], onRemoveFilter, suggestionOptions = [], onSelectSuggestion }) => {
    return (
        <Box sx={{ position: 'relative', width: '100%'}}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px', width: '100%' }}>
                <Box
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        flex: 1,
                        minHeight: '40px',
                        height: 'auto',
                        borderRadius: '8px',
                        border: '1px solid #D5DCE1',
                        background: '#FFF',
                        boxShadow: '0px 1px 2px 0px rgba(6, 21, 34, 0.05)',
                        px: '16px',
                        pl: activeFilters.length > 0 ? '4px' : '16px',
                        py: '4px',
                        flexWrap: 'wrap',
                        gap: '8px',
                        transition: 'border-color 0.2s ease',
                        '&:focus-within': {
                            borderColor: '#148DFD',
                        },
                    }}
                >
                    {/* Active Filter Flags */}
                    {activeFilters.map((filter, index) => (
                        <React.Fragment key={index}>
                            <Box
                                sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    height: '32px',
                                    padding: '0 8px',
                                    borderRadius: '5px',
                                    border: '1px solid #148DFD',
                                    background: '#F3FBFF',
                                    color: '#061522',
                                    fontFamily: 'Inter',
                                    fontSize: '14px',
                                    fontWeight: 400,
                                    whiteSpace: 'nowrap',
                                    cursor: 'default',
                                }}
                            >
                                {filter.label}
                            </Box>
                            {filter.value && (
                                <Box
                                    sx={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        height: '32px',
                                        padding: '0 8px',
                                        borderRadius: '5px',
                                        border: '1px solid #148DFD',
                                        background: '#F3FBFF',
                                        color: '#061522',
                                        fontFamily: 'Inter',
                                        fontSize: '14px',
                                        fontWeight: 400,
                                        whiteSpace: 'nowrap',
                                        cursor: 'default',
                                    }}
                                >
                                    {filter.value}
                                </Box>
                            )}
                        </React.Fragment>
                    ))}

                    <Box
                        component="input"
                        type="text"
                        placeholder="Search for anything, or use any combination of filters below"
                        value={value}
                        onChange={(e) => onChange(e.target.value)}
                        onKeyDown={(e) => {
                            if (e.key === 'Backspace' && !value && activeFilters.length > 0 && onRemoveFilter) {
                                onRemoveFilter(activeFilters[activeFilters.length - 1]);
                            }
                        }}
                        autoFocus
                        sx={{
                            flex: 1,
                            minWidth: '100px',
                            border: 'none',
                            outline: 'none',
                            fontFamily: 'Inter',
                            fontSize: '14px',
                            fontWeight: 400,
                            lineHeight: '18px',
                            color: '#061522',
                            background: 'transparent',
                            '&::placeholder': {
                                color: '#93A1B0',
                                fontSize: '14px',
                                fontFamily: 'Inter',
                            },
                        }}
                    />
                    <SearchIcon style={{ width: 16, height: 16, flexShrink: 0, marginLeft: 12 }} />
                </Box>
                <Button
                    onClick={onClear}
                    sx={{
                        minWidth: '112px',
                        height: '40px',
                        borderRadius: '8px',
                        border: '1px solid #D5DCE1',
                        background: '#FFF',
                        boxShadow: '0px 1px 2px 0px rgba(6, 21, 34, 0.05)',
                        color: '#405261',
                        fontFamily: 'Inter',
                        fontSize: '14px',
                        fontWeight: 500,
                        lineHeight: '18px',
                        textTransform: 'none',
                        flexShrink: 0,
                        '&:hover': {
                            background: '#F9FAFA',
                            borderColor: '#C5CED6',
                        },
                    }}
                >
                    Clear
                </Button>
            </Box>

            {suggestionOptions.length > 0 && (
                <Box
                    sx={{
                        position: 'absolute',
                        top: 'calc(100% + 4px)',
                        left: 0,
                        width: 'calc(100% - 124px)',
                        zIndex: 1,
                    }}
                >
                    <Box sx={{
                        width: '100%',
                        borderRadius: '8px',
                        border: '1px solid #D5DCE1',
                        background: '#FFF',
                        boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)',
                        maxHeight: '300px',
                        overflowY: 'auto',
                        padding: '8px 0',
                    }}>
                        <Box sx={{ padding: '8px 16px', marginBottom: '4px' }}>
                            <span style={{ fontSize: '10px', color: '#405261', fontFamily: 'Inter' }}>
                                Continue typing to filter the values below. Tab to select.
                            </span>
                        </Box>
                        {suggestionOptions.map((option, index) => (
                            <Box
                                key={index}
                                onClick={() => onSelectSuggestion && onSelectSuggestion(option)}
                                sx={{
                                    padding: '10px 16px',
                                    fontFamily: 'Inter',
                                    fontSize: '14px',
                                    color: '#556575',
                                    cursor: 'pointer',
                                    '&:hover': {
                                        background: '#F9FAFA',
                                        color: '#061522',
                                    },
                                }}
                            >
                                {typeof option === 'object' ? option.label : option}
                            </Box>
                        ))}
                    </Box>
                </Box>
            )
            }
        </Box >
    );
};

export default SearchInput;
